const PRODUCT_SEARCH_INPUT_SELECTOR = '[data-product-search-input]'
const isFeedPage = () => window.location.pathname === '/feed'

export function focusProductSearchInput(delay = 0) {
  if (!isFeedPage()) return

  window.setTimeout(() => {
    if (!isFeedPage()) return

    const searchInput = document.querySelector<HTMLInputElement>(
      PRODUCT_SEARCH_INPUT_SELECTOR
    )
    if (!searchInput || searchInput.disabled) return

    const hasOpenModal = Array.from(
      document.querySelectorAll<HTMLElement>('.ant-modal-wrap')
    ).some((modal) => !modal.classList.contains('ant-modal-hidden'))
    if (hasOpenModal) return

    const activeElement = document.activeElement
    const isEditingAnotherField =
      activeElement instanceof HTMLElement &&
      activeElement !== searchInput &&
      activeElement.matches('input, textarea, select, [contenteditable="true"]')
    const isInsideSelectedFilters =
      activeElement instanceof Element &&
      document.querySelector('[data-selected-filters]')?.contains(activeElement)

    if (isEditingAnotherField || isInsideSelectedFilters) return

    searchInput.focus({ preventScroll: true })
  }, delay)
}
